import React from 'react';

import Badge from './Badge';

import useCounter from '../hooks/useCounter';

type TBadgeCounter = {
  endpoint?: string;
  badgeKey?: string;
  badgeCount?: number;
  badgeName: string;
  extraCount?: number;
};

const BadgeCounter = ({ endpoint, badgeKey, badgeCount = 0, badgeName, extraCount }: TBadgeCounter) => {
  let counter = useCounter(badgeCount, { badgeKey, badgeName, endpoint });

  if (Number.isInteger(counter)) {
    counter += extraCount ?? 0;
  }

  if (!counter) {
    return null;
  }

  return (
    <Badge kind="callToAction" badge-name={badgeName}>
      {counter}
    </Badge>
  );
};

export default BadgeCounter;
